var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoDataIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3723 15.2357L1.54066 0.0413898C1.45763 -0.000124737 1.3746 -0.000124737 1.33309 0.0413898L0.585823 0.581079C0.544309 0.664108 0.544309 0.747138 0.585823 0.788652L12.4175 15.9415C12.459 16.0245 12.542 16.0245 12.6251 15.983L13.3723 15.4018C13.4138 15.4018 13.4138 15.3188 13.3723 15.2357Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23911 1.74349H7.31118V5.35525C7.31118 5.52131 7.39421 5.72889 7.51876 5.85343C7.6433 5.97797 7.80936 6.061 8.01693 6.061H11.6287V11.707C11.6287 11.79 11.6702 11.8315 11.7532 11.8315H12.7081C12.7911 11.8315 12.8326 11.79 12.8326 11.707V4.69102C12.8326 4.56648 12.7911 4.40042 12.6666 4.31739L9.09631 0.747137C9.01328 0.664108 8.84722 0.581079 8.72268 0.581079H4.23911C4.15608 0.581079 4.11456 0.622594 4.11456 0.705623V1.66046C4.11456 1.70197 4.15608 1.74349 4.23911 1.74349ZM8.47359 1.785L11.6287 4.94011H8.47359V1.785Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76054 14.2809H2.28792V4.35891C2.28792 4.27588 2.24641 4.23436 2.16338 4.23436H1.25006C1.16703 4.23436 1.12551 4.27588 1.12551 4.35891V14.9451C1.12551 15.2357 1.3746 15.4848 1.6652 15.4848H9.80206C9.88509 15.4848 9.9266 15.4433 9.9266 15.3603V14.4469C9.88509 14.3639 9.84357 14.2809 9.76054 14.2809Z",
    fill: "#D9D9D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataIcon);
export default __webpack_public_path__ + "static/media/no-data-icon.16d4a7cb.svg";
export { ForwardRef as ReactComponent };